import { createFileRoute, Outlet, useParams } from '@tanstack/react-router';
import { AnimatePresence } from 'motion/react';

import { parseProjectSearch } from '../../../features/projects/model/filters.ts';
import { ProjectPage } from '../../../features/projects/ui/project-page.tsx';
import { TaskPanel } from '../../../features/projects/ui/task-panel.tsx';
import { requirePermissionRoute } from '../../../lib/permissions.ts';

export const Route = createFileRoute('/_app/projects/$id')({
  validateSearch: (search: Record<string, unknown>) => parseProjectSearch(search),
  beforeLoad: requirePermissionRoute('projects.use'),
  component: ProjectRoute,
});

/** Проект на всю страницу; задача — панель поверх него (`/projects/$id/tasks/$taskId`). */
function ProjectRoute() {
  const { id } = Route.useParams();
  const { taskId } = useParams({ strict: false });
  return (
    <>
      <ProjectPage key={id} id={id} />
      <Outlet />
      {/* Постоянный key: переход к соседней задаче не закрывает и не открывает панель заново. */}
      <AnimatePresence initial={false}>
        {taskId ? <TaskPanel key="panel" projectId={id} taskId={taskId} /> : null}
      </AnimatePresence>
    </>
  );
}
